export default __webpack_public_path__ + "static/media/card2.f2bac114.png";